import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { QUERY_STALE_TIME } from '@/constants/queryDefaults';
import type { MarketApps } from '@/features/Dashboard/types';

import { marketsApi } from './markets.api';

export const marketsOptions = {
  marketsList: (verificationToken?: string) =>
    queryOptions({
      queryKey: ['marketsList', verificationToken] as const,
      queryFn: () => marketsApi.getMarketsList(verificationToken),
      staleTime: QUERY_STALE_TIME.stable,
      retry: false
    }),

  market: (marketId: string | undefined) =>
    queryOptions({
      queryKey: ['market', marketId],
      queryFn: () => marketsApi.getMarket(marketId as string),
      enabled: Boolean(marketId),
      refetchOnWindowFocus: true,
      staleTime: QUERY_STALE_TIME.standard
    }),
  widgets: (marketId: string | null) =>
    queryOptions({
      queryKey: ['marketWidgets', marketId],
      queryFn: () => marketsApi.getMarketWidgets(marketId as string),
      enabled: Boolean(marketId),
      refetchOnWindowFocus: true,
      staleTime: QUERY_STALE_TIME.standard
    }),
  preview: (template: MarketApps | undefined, enabled = true) =>
    queryOptions({
      queryKey: ['marketPreview', template],
      queryFn: () => marketsApi.previewMarket(template as MarketApps),
      placeholderData: keepPreviousData,
      enabled: Boolean(template && template.length > 0 && enabled),
      refetchOnWindowFocus: true,
      staleTime: QUERY_STALE_TIME.standard
    })
};
